import React from 'react'
import PageHero from '../components/PageHero'
import PageLayout from '../components/PageLayout'

const SpecialEventsPage: React.FC = () => {
    return (
        <PageLayout>
            <PageHero title="Event Calendar" image="./img/seheader.jpg" imageAlt="A collage celebrating House special events" />
            <section className="py-5">
                <div className="container">
                    <p className="lead readable-copy text-center mb-5">Find upcoming House events, gatherings, workshops, and community programs.</p>
                    <div data-tockify-component="calendar" data-tockify-calendar="houseevents"></div>
                </div>
            </section>
        </PageLayout>
    )
}

export default SpecialEventsPage
